import { Location } from 'vue-router'
import { File } from '@/typings/api/File'

import { createDownload, createEdit, DELETE } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { FILES_ROUTES as ROUTES } from './utils'
import { USERS_ROUTES } from '../Users/utils'

const getDownloadHref = (data: File) => data.raw_file?.url

const getEditRoute = (data: File): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createDownload<File>(getDownloadHref),
  createEdit<File>(getEditRoute),
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: true,
    width: 80,
  },
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: (data: File): Location => ({
      name: ROUTES.VIEW,
      params: { id: data.id.toString() },
    }),
  },
  {
    text: 'Владелец',
    value: 'owner',
    sortable: false,
    getRoute: (data: File): Location => ({
      name: USERS_ROUTES.VIEW,
      params: { id: data.owner.id.toString() },
    }),
  },
  {
    text: 'Теги',
    value: 'tags',
    sortable: false,
    width: 180,
    field: (value: File['tags']) => value?.join(', '),
  },
  {
    text: 'Дата изменения',
    value: 'updated_at',
    sortable: false,
    width: 130,
    field: (value: File['updated_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 140,
    field: (value: File['created_at']) => (
      value && dateFormatter(value)
    ),
  },
])
